/* Spanish catalog mirroring locale-manual-preview-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  "manualPreview.reset": "Restablecer",
  "manualPreview.title": "Contabilidad",
  "manualPreview.details": "Detalles",
  "manualPreview.summary": "Resumen por cuenta",
  "manualPreview.date": "Fecha",
  "manualPreview.account": "Cuenta",
  "manualPreview.vat": "Código de IVA",
  "manualPreview.before": "Saldo anterior",
  "manualPreview.amount": "Importe",
  "manualPreview.after": "Saldo posterior",
  "manualPreview.debit": "Debe",
  "manualPreview.credit": "Haber",
  "manualPreview.net": "Variación neta",
  "manualPreview.warning.balances": "Los saldos no están disponibles en los registros contables. Los asientos se muestran sin saldos anteriores ni posteriores.",
  "manualPreview.warning.editing": "En las correcciones, aquí se muestra el asiento de sustitución. No se muestran los saldos anteriores ni posteriores porque la corrección también puede anular un justificante anterior.",
  "manualPreview.warning.years": "Los asientos abarcan varios años naturales. Se muestran las líneas del diario, pero los saldos anteriores y posteriores no se proyectan entre años.",
  "manualPreview.warning.country": "La vista previa requiere un país contable o no admite el tratamiento de IVA seleccionado para ese país."
});
